import React from 'react'
import { Bar, BarProps, Cell } from 'recharts'

import BarCell from './Cell'

type Props = BarProps & {
  borderRadius?: number
  color: string
  colorHovered: string
  hoveredIndex: number | null
  graphData?: any[]
}

const CustomBar = ({
  graphData,
  borderRadius = 15,
  hoveredIndex,
  color,
  colorHovered,
  ref,
  ...rest
}: Props) => {
  return (
    <Bar fill={color} shape={<BarCell borderRadius={borderRadius} />} {...rest}>
      {graphData?.map((_, index) => {
        return (
          <Cell key={index} cursor="pointer" fill={hoveredIndex === index ? colorHovered : color} />
        )
      })}
    </Bar>
  )
}

export default CustomBar
